import React from 'react';

import AjaxContext from './ajaxContext';
import useAjaxProvider from './useAjaxProvider';

interface AjaxProviderProps {
	children: any;
	baseURL: string;
	adminBaseUrl: string;
}

const AjaxProvider: React.FC<AjaxProviderProps> = ({ children, baseURL, adminBaseUrl }) => {
	const { getData, postData, putData } = useAjaxProvider({ baseURL, adminBaseUrl });
	return <AjaxContext.Provider value={{ getData, postData, putData }}>{children}</AjaxContext.Provider>;
};
export default AjaxProvider;
